import { Box, Typography } from "@mui/material";
import { ToggleViewType } from "src/constants/services";
import { CategoryType } from "src/store/types/categoriesTypes";

import { CategoryCard } from "../CategoryCard/CategoryCard";
import { NewCategoryCard } from "../NewCategoryCard/NewCategoryCard";

import { CategoriesListSectionProps } from "./CategoriesListSection.types";

export function CategoriesListSection ({
  data,
  onSelect,
  onAddNewCategory,
}: CategoriesListSectionProps) {
  return (
    <Box
      sx={{
        display: "flex",
        marginTop: "32px",
        padding: "0 16px 0",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        {data.map((category: any) => (
          <CategoryCard
            key={category.id}
            onClick={() => onSelect(category)}
            data={category}
          />
        ))}
        {
          data.length > 10 ? <NewCategoryCard onClick={onAddNewCategory} /> : null
        }
      </Box>
    </Box>
  );
}
